<template>
  <div class="bank">
    <sirui-search
      ref="bankDataSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 上传组件 -->
    <BUploadExcel ref="uploadExcelRef" :uploadResultHandler="uploadResultHandler" />
  </div>
</template>

<script>
  import { searchColumns, defaultMenuBtnList, defaultTableColumn } from './index.js';
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import BANK_API from '@/api/bankMasterData';
  export default {
    name: 'BankMasterData',
    data() {
      return {
        query: {
          bankCode: '',
          branchName: '',
          bankUnionNumber: '',
          swiftCode: '',
        },
        searchColumns,
        loading: false,
        tableData: [],
        columnList: [],
        menuButtonList: [],
      };
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          // TODO 后端还没处理好返回数据，前端先这样处理
          this.menuButtonList = e.length > 0 ? e : defaultMenuBtnList;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn).then((res) => {
          this.columnList = res;
        });
      },
      // 获取表格数据
      async getTableData() {
        const { pageNum, pageSize } = this.$refs.siruiTable?.page;
        const data = {
          ...this.query,
          pageSize,
          pageNumber: pageNum,
        };
        const result = await this.$axios.post(BANK_API.GET_BANK_LIST, data);
        console.log(result);
      },
      resetBtnClickHandler() {
        this.query = {
          bankCode: '',
          branchName: '',
          bankUnionNumber: '',
          swiftCode: '',
        };
      },
      // 查询按钮
      queryBtnClickHandler() {
        console.log(this.query, '查询条件');
        this.getTableData();
      },
      // 按钮选择
      chooseClick(type) {
        console.log(type, '类型');
        if (type === 'enable') {
          console.log('启用');
        } else if (type === 'forbid') {
          console.log('禁用');
        } else if (type === 'import') {
          this.$refs.uploadExcelRef.startFile();
        }
      },
      uploadResultHandler(res) {
        console.log(res, '银行组件中接收上传结果');
      },
      // 双击
      dblclickEvent(rowData) {
        console.log(rowData);
      },
      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        // this.multipleSelection = row;
      },
      async _updateStatus(type) {
        const data = { targetStatus: type, ids: [] };
        const { code } = await this.$axios.post(BANK_API.UPDATE_BANK_STATUS, data);
        if (code === 0) {
          this.$message.success('修改成功');
        } else {
          this.$message.error('修改失败');
        }
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
    mounted() {
      this.getButtonList();
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    components: {
      SiruiSearch,
      SiruiTable,
    },
  };
</script>

<style></style>
